<div class="widget-preview-dialog-component">
  <div class="dialog-content">
    @if (loadingWidget === false) {
      <div class="browser-container" [class.mobile-preview]="isMobilePreview">
        @if (!isMobilePreview) {
          <div class="browser-header">
            <div class="column left">
              <span class="dot dot-1"></span>
              <span class="dot dot-2"></span>
              <span class="dot dot-3"></span>
            </div>
            <div class="column middle">
              <div class="url-bar"></div>
            </div>
            <div class="column right">
              <mat-icon>more_vert</mat-icon>
            </div>
          </div>
        }
        <div class="content">
          @if (imageUrls && imageUrls.length > 0) {
            <div [ngClass]="'widget-position--' + imageUrls[0].position" class="ratio-4-3">
              @if (!isDarkTheme) {
                <img
                  [src]="imageUrls[0].imageUrl"
                  onError="this.src='/assets/img/campaign/preview_no_image.png'"
                  data-test="widget-preview"
                  class="preview-image"
                  [class.mobile-preview-image]="isMobilePreview" />
              }
              @if (isDarkTheme) {
                <img
                  [src]="imageUrls[0].imageUrl"
                  onError="this.src='/assets/img/campaign/thumbnail-darkmode'"
                  data-test="widget-preview"
                  class="preview-image"
                  [class.mobile-preview-image]="isMobilePreview" />
              }
            </div>
          } @else {
            <div class="default-preview-image">
              <mat-icon>photo</mat-icon>
            </div>
          }
        </div>
      </div>
    }
    @if (loadingWidget === true) {
      <mat-spinner class="spinner"></mat-spinner>
    }
  </div>

  @if (loadingWidget !== true) {
    <div class="actions-row dialog-row">
      <button class="secondary-button" mat-stroked-button (click)="closeDialog()">{{ "generic.close" | translate | uppercase }}</button>
      @if (widgetLink) {
        <a class="primary-button" mat-stroked-button [href]="widgetLink" target="_blank">
          <mat-icon>open_in_new</mat-icon>
          @if (currentPageTitle === PageTitle.Sales) {
            <span>{{ "generic.go-to-campaign" | translate | uppercase }}</span>
          } @else {
            <span>{{ "generic.open" | translate | uppercase }}</span>
          }
        </a>
      }
    </div>
  }
</div>
